import { makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { Paragraph } from '../../elements';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
const useStyles = makeStyles(theme => ({
    Dropzone: ({ highlighted, submitError }) => ({
        height: '100px',
        width: '100%',
        backgroundColor: highlighted ? 'rgb(173, 230, 247)' : '#fff',
        border: submitError ? '2px dashed #D10074' : `2px dashed #DFDFDE`,
        color: `##3D3D3C`,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        fontSize: '16px'
    }),
    Icon: {
        opacity: 0.3,
        height: '40px',
        width: '40px',
        display: 'inline'
    },
    FileInput: {
        display: 'none'
    },
    Paragraph: {
        width: '50px'
    },
    ResetMargin: {
        margin: '0'
    }
}));
const Dropzone = ({ files, //this property is needed to trigger rerendering of the component
onFilesAdded: propOnFilesAdded, submitError, disabled, acceptInput, single, hideSubText, textId, subTextId }) => {
    const intl = useIntl();
    const [highlighted, setHighlighted] = useState(false);
    const styles = useStyles({ highlighted, submitError });
    const fileInputRef = React.createRef();
    const parentFilesAdd = (list) => propOnFilesAdded([...list]);
    const openFileDialog = () => {
        if (disabled)
            return;
        fileInputRef.current.click();
    };
    const onDragOver = (event) => {
        event.preventDefault();
        if (disabled)
            return;
        setHighlighted(true);
    };
    const onDragLeave = () => {
        setHighlighted(false);
    };
    const onDrop = (event) => {
        event.preventDefault();
        if (disabled)
            return;
        parentFilesAdd(event.dataTransfer.files);
        setHighlighted(false);
    };
    const displaySubText = !hideSubText;
    const multiple = !single;
    return (React.createElement("div", { className: classnames(styles.Dropzone, "dropzone"), onClick: openFileDialog, onDragLeave: onDragLeave, onDragOver: onDragOver, onDrop: onDrop },
        React.createElement("input", { className: styles.FileInput, multiple: multiple, onChange: e => parentFilesAdd(e.target.files), ref: fileInputRef, value: '', type: "file", accept: acceptInput }),
        React.createElement("img", { alt: "upload", className: styles.Icon, src: "/baseline-cloud_upload-24px.svg" }),
        React.createElement(Paragraph, { className: styles.ResetMargin }, textId ? intl.formatMessage({ id: textId }) : intl.formatMessage({ id: 'common.attachFile' })),
        displaySubText && React.createElement(Paragraph, { className: styles.ResetMargin, small: true }, subTextId ? intl.formatMessage({ id: subTextId }) : intl.formatMessage({ id: 'common.attachFileSubtext' }))));
};
export default Dropzone;
